var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoClean(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-fde0c5aa": "",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    className: "iconLeft",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a857240b-de45-40a5-af64-87c1eceae5b5",
    stroke: "none",
    fill: "#4169e1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.983 10.59l17.018 88.223-5.872-59.049 29.021-1.892-.054-9.883L64.549 1 53.622 18.977z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.389 54.548l5.16-53.541-8.74 39.716-19.612 1.045 1.57 20.462-7.766 36.583 12.057-39.899z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8 67.182l.549-10.453-15.979 3.755-.032 11.797-17.337 26.532 21.68-27.616zM65.711 62.394l14.841-4.731 1.509-12.532-15.899 2.095zM72.07 44.502l10.988-1.417 1.581-10.278-8.079-.373L64.549 1l8.43 30.967z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.413 31.294l1.256-9.506-9.544-2.694L64.549 1l14.483 22.437-.422 7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoClean);
export default __webpack_public_path__ + "static/media/logo-clean.da8ba426239c9f5a64bec004c8cc04a2.svg";
export { ForwardRef as ReactComponent };